module.exports = __webpack_public_path__ + "img/table-pin-green.ae82e10b.svg";